<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon awesome-pen.png" alt width="22" height="22" />
      <p class="title-bk">生徒編集</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: 'student-id-detail', params: { id } }">戻る</router-link>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <a href="/pdf/form_student.pdf" target="_blank">フォームの説明を確認</a>
    </div>
    <div class="container">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(confirmEdited)" ref="form">
          <table class="table table-form">
            <tbody>
              <ChoiceField
                v-model="corporationChoiceFieldMultiModels"
                extraRules="required_select"
                label="法人名（法人ID）"
                placeholder="選択して下さい"
                resourceType="corporation"
                modelFieldName="corporation"
                :choiceDisable="loggedInAsCorporation || loggedInAsBrand || loggedInAsSchool"
                :childFieldNames="['brand', 'school', 'course', 'tamaiClass']"
                :formData="currentStudent"
              />
              <ChoiceField
                v-model="brandChoiceFieldMultiModels"
                extraRules="required_select"
                label="ブランド名（ブランドID）"
                placeholder="選択して下さい"
                resourceType="brand"
                modelFieldName="brand"
                :choiceDisable="loggedInAsBrand || loggedInAsSchool || isEmpty(currentStudent.corporation)"
                :childFieldNames="['school', 'course', 'tamaiClass']"
                :formData="currentStudent"
              />
              <ChoiceField
                v-model="schoolChoiceFieldMultiModels"
                extraRules="required_select"
                label="教場名（教場ID）"
                placeholder="選択して下さい"
                resourceType="school"
                modelFieldName="school"
                :choiceDisable="loggedInAsSchool || isEmpty(currentStudent.brand)"
                :childFieldNames="['tamaiClass']"
                :formData="currentStudent"
              />
              <ChoiceField
                v-model="courseChoiceFieldMultiModels"
                extraRules="required_select"
                label="コース名（コースID）"
                placeholder="選択して下さい"
                resourceType="course"
                modelFieldName="course"
                :choiceDisable="isEmpty(currentStudent.brand)"
                :childFieldNames="['tamaiClass']"
                :formData="currentStudent"
              />
              <ChoiceField
                v-model="tamaiClassChoiceFieldMultiModels"
                extraRules="required_select"
                label="クラス名（クラスID）"
                placeholder="選択して下さい"
                resourceType="class"
                modelFieldName="tamaiClass"
                :choiceDisable="
                  isEmpty(currentStudent.brand) || isEmpty(currentStudent.school) || isEmpty(currentStudent.course)
                "
                :formData="currentStudent"
              />
              <br />
              <tr>
                <th scope="row">生徒ID</th>
                <td />
                <td>{{ currentStudent.uid }}</td>
              </tr>
              <br />
              <TextField v-model="currentStudent.name" label="生徒名" extraRules="required" />
              <TextField
                v-model="currentStudent.nameKana"
                label="生徒名（フリガナ）"
                placeholder="全角カタカナ"
                extraRules="required"
              />
              <TextField
                v-model="currentStudent.nameRomaji"
                label="生徒名（ローマ字）"
                placeholder="半角英数"
                extraRules="required"
              />
              <tr>
                <th scope="row" width="25%">生年月</th>
                <td width="10%">
                  <span class="bg-red">必須</span>
                </td>
                <td class="form-inline no-margin-top">
                  <ValidationProvider
                    mode="eager"
                    rules="required_select"
                    class="v-select-birth"
                    v-slot="{ classes, valid, invalid, errors }"
                  >
                    <v-select
                      tag="div"
                      v-model="currentStudent.yearOfBirth"
                      placeholder="選択してください"
                      class="form-control select-year"
                      :class="classes"
                      :clearable="false"
                      :options="years"
                    />
                    <span class="select-text">年</span>
                    <div class="invalid-feedback" v-show="invalid">{{ errors[0] }}</div>
                  </ValidationProvider>
                  <ValidationProvider
                    mode="eager"
                    rules="required_select"
                    class="v-select-birth"
                    v-slot="{ classes, valid, invalid, errors }"
                  >
                    <v-select
                      tag="div"
                      v-model="currentStudent.monthOfBirth"
                      placeholder="選択してください"
                      class="form-control select-month"
                      :class="classes"
                      :clearable="false"
                      :options="months"
                    />
                    <span class="select-text">月</span>
                    <div class="invalid-feedback" v-show="invalid">{{ errors[0] }}</div>
                  </ValidationProvider>
                </td>
              </tr>
              <SelectField
                label="性別"
                extraRules="required_select"
                inputClass="col-lg-3"
                placeholder="選択してください"
                :options="genders"
                optionValue="id"
                optionLabel="name"
                v-model="currentStudent.gender.id"
              />
              <SelectField
                label="国籍"
                extraRules="required_select"
                inputClass="col-lg-8"
                placeholder="選択してください"
                :options="countries"
                optionValue="id"
                optionLabel="companyjp"
                v-model="currentStudent.citizenship.id"
              />
              <SelectField
                label="居住国"
                extraRules="required_select"
                inputClass="col-lg-8"
                placeholder="選択してください"
                :options="countries"
                optionValue="id"
                optionLabel="companyjp"
                v-model="currentStudent.residence.id"
              />
              <SelectField
                label="学年"
                extraRules="required_select"
                inputClass="col-lg-3"
                placeholder="選択してください"
                :options="schoolYears"
                optionValue="id"
                optionLabel="name"
                v-model="currentStudent.schoolYear.id"
              />
              <TextField
                v-model="currentStudent.address"
                label="住所"
                placeholder="例）京都府京都市"
                extraRules="required"
              />
              <br />
              <tr>
                <th scope="row">学習中の教材</th>
                <td />
                <td>{{ currentStudentTeachingMaterial }}</td>
              </tr>
              <TeachingMaterialCheckBox
                label="来月からの教材変更"
                inputClass="col-lg-8"
                :options="nextTeachingMaterials"
                optionValue="code"
                optionLabel="name"
                v-model="currentStudent.nextFiguredTeachingMaterialCodes"
                :checkedLists="currentStudent.nextFiguredTeachingMaterialCodes"
                :disableBoxes="currentStudent.isImmediately"
              />
              <tr v-if="hasAdminPrivilege && isStudentActive">
                <th scope="row" width="25%">即日変更</th>
                <td width="10%"></td>
                <td>
                  <label
                    ><input
                      class="margin-right-5"
                      type="checkbox"
                      v-model="currentStudent.isImmediately"
                      :disabled="!hasSelectedNextTeachingMaterial(currentStudent.nextFiguredTeachingMaterialCodes)"
                    />即日変更する</label
                  >
                </td>
              </tr>
              <tr v-if="isStudentActive">
                <th scope="row" width="25%">休会開始月予約</th>
                <td width="10%">
                  <span class="bg-red">必須</span>
                </td>
                <td class="form-inline no-margin-top">
                  <ValidationProvider
                    mode="eager"
                    rules="required_select"
                    class="v-select-birth"
                    v-slot="{ classes, valid, invalid, errors }"
                  >
                    <v-select
                      tag="div"
                      v-model="currentStudent.deactivateMonth"
                      placeholder="選択してください"
                      class="select-control"
                      :clearable="false"
                      :options="deactivateMonthJPs"
                      label="text"
                    />
                    <div class="invalid-feedback" v-show="invalid">{{ errors[0] }}</div>
                  </ValidationProvider>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="text-center">
            <button type="submit" class="btn-confirm">確認</button>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState, mapActions, mapGetters } from 'vuex';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import store from '@/store/index.js';
import { studentBirthYears, monthsOfYear, nextNMonthJPs } from '@/utils/year_helpers';
import { nextNDayJPs } from '@/utils/date_helpers';
import filter from 'lodash/filter';
import uniqBy from 'lodash/uniqBy';
import isEmpty from 'lodash/isEmpty';
import ChoiceField from '@/components/forms/ChoiceField.vue';
import TextField from '@/components/forms/TextField.vue';
import SelectField from '@/components/forms/SelectField.vue';
import TeachingMaterialCheckBox from '@/components/forms/TeachingMaterialCheckBox.vue';
import {
  basicCorporationNameIdPresent,
  basicBrandNameIdPresent,
  basicSchoolNameIdPresent,
  basicCourseNameIdPresent,
  basicTamaiClassNameIdPresent,
} from '@/presenters/fields';
import { filterTeachingMaterialsByProducts } from '@/utils/teaching_material_helpers';

export default {
  data() {
    return {
      originalNextFiguredTeachingMaterialCodes: null,
    };
  },
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  components: {
    ValidationObserver,
    ValidationProvider,
    ChoiceField,
    TextField,
    SelectField,
    TeachingMaterialCheckBox,
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (routeFrom.name != 'choice') {
      store.dispatch('form/clearFormDataStored');
    }

    if (routeTo.params.id) {
      let prevFormData = store.state.form.prevFormData;

      if (prevFormData) {
        // Reset content of pulldown when reselecting corporation.
        prevFormData.nextFiguredTeachingMaterialCodes = [];
        prevFormData.isImmediately = false;
        store.dispatch('student/restoreFormData', prevFormData).then(() => {
          next();
        });
      } else {
        store.dispatch('student/fetchStudent', routeTo.params.id).then(() => {
          next();
        });
      }
    } else {
      next();
    }
  },
  async mounted() {
    await this.fetchSchoolYears();
    this.originalNextFiguredTeachingMaterialCodes = this.student.nextFiguredTeachingMaterialCodes;
  },
  computed: {
    corporationChoiceFieldMultiModels() {
      return basicCorporationNameIdPresent(this.currentStudent.corporation);
    },
    brandChoiceFieldMultiModels() {
      return basicBrandNameIdPresent(this.currentStudent.brand);
    },
    schoolChoiceFieldMultiModels() {
      return basicSchoolNameIdPresent(this.currentStudent.school);
    },
    courseChoiceFieldMultiModels() {
      return basicCourseNameIdPresent(this.currentStudent.course);
    },
    tamaiClassChoiceFieldMultiModels() {
      return basicTamaiClassNameIdPresent(this.currentStudent.tamaiClass);
    },
    years() {
      return studentBirthYears(1980);
    },
    months() {
      return monthsOfYear();
    },
    nextTeachingMaterials() {
      const allTeachingMaterials = this.teachingMaterials;
      const userProducts = this.currentStudent.corporation.figuredProducts;
      let nextMaterials = filterTeachingMaterialsByProducts(allTeachingMaterials, userProducts);
      // 法人の利用教材に含まれない教材への変更予約がされていれば、その教材もプルダウンに含める。
      if (!isEmpty(this.originalNextFiguredTeachingMaterialCodes)) {
        const nextTeachingMaterial = filter(allTeachingMaterials, (teachingMaterial) => {
          return this.originalNextFiguredTeachingMaterialCodes.includes(teachingMaterial.code);
        });
        nextMaterials = nextMaterials.concat(nextTeachingMaterial);
        nextMaterials = uniqBy(nextMaterials, 'code');
      }
      return nextMaterials;
    },
    deactivateMonthJPs() {
      let numberOfMonths = 12;
      let arrayOfMonths = [];
      if (Vue.config.stagingBuild) {
        arrayOfMonths = nextNDayJPs(numberOfMonths);
      } else {
        arrayOfMonths = nextNMonthJPs(numberOfMonths);
      }
      arrayOfMonths.unshift({
        value: null,
        text: '予約しない',
      });
      return arrayOfMonths;
    },
    currentStudent() {
      if (this.editingStudent) {
        return this.editingStudent;
      } else {
        return this.student;
      }
    },
    currentStudentTeachingMaterial() {
      return this.getTeachingMaterialNamesByCodes(this.currentStudent.figuredTeachingMaterialCodes);
    },
    ...mapState({
      student: (state) => state.student.student,
      editingStudent: (state) => state.student.editingStudent,
      genders: (state) => state.gender.genders,
      countries: (state) => state.country.countries,
      schoolYears: (state) => state.school_year.schoolYears,
      teachingMaterials: (state) => state.teaching_material.teachingMaterials,
    }),
    ...mapGetters('student', ['isStudentActive']),
    ...mapGetters('teaching_material', ['getTeachingMaterialNamesByCodes']),
    ...mapGetters('auth', ['loggedInAsCorporation', 'loggedInAsBrand', 'loggedInAsSchool']),
    ...mapGetters('role', ['hasAdminPrivilege']),
  },
  methods: {
    confirmEdited() {
      this.$logger.debug('Started Editing: ' + JSON.stringify(this.currentStudent));
      this.startEditingStudent(this.currentStudent);
      this.$router.push({ name: 'student-id-confirm', params: { id: this.id } });
    },
    hasSelectedNextTeachingMaterial(nextTeachingMaterialArray = []) {
      if (nextTeachingMaterialArray.length == 0) {
        return false;
      } else {
        return true;
      }
    },
    ...mapActions('student', ['startEditingStudent']),
    ...mapActions('school_year', ['fetchSchoolYears']),
  },
};
</script>

<style lang="scss" scoped>
.section-title {
  padding-bottom: 6px;
}
.section-subtitle {
  padding-bottom: 12px;
}
form.inline-form {
  display: inline-block;
}
.checkbox .checkbox-input {
  margin-right: 5px;
}
.radio .radio-input {
  margin-right: 5px;
}
.radio .reservation-select {
  display: inline-grid;
}
.img-inline {
  margin-left: 5px;
}
.body-td-explain {
  margin-left: 5px;
  font-size: 10px;
}
.line-break {
  width: 100%;
}
.btn-confirm {
  margin-left: 0px;
}

/deep/ .v-select-birth {
  .select-month,
  .select-year {
    padding: 0px 2px 0px 10px;
    max-width: initial;
    margin-right: 10px;
    .vs__dropdown-toggle {
      width: 146px;
    }
  }
  .select-text {
    margin-right: 35px;
  }
}
.select-control {
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 13px;
  width: 175px;
}
.caution {
  margin-bottom: 20px;
}
</style>
